export const convertToMonths = numbers => {
  if (!numbers) return
  const months = [
    { name: "Jan", number: 1 },
    { name: "Feb", number: 2 },
    { name: "Mar", number: 3 },
    { name: "Apr", number: 4 },
    { name: "May", number: 5 },
    { name: "Jun", number: 6 },
    { name: "Jul", number: 7 },
    { name: "Aug", number: 8 },
    { name: "Sep", number: 9 },
    { name: "Oct", number: 10 },
    { name: "Nov", number: 11 },
    { name: "Dec", number: 12 },
  ]

  const sortedNumbers = [...new Set(numbers)].sort((a, b) => a - b)

  let result = ""
  let currentRange = [sortedNumbers[0]]

  for (let i = 1; i < sortedNumbers.length; i++) {
    if (sortedNumbers[i] - sortedNumbers[i - 1] > 1) {
      if (currentRange.length === 1) {
        result += months[currentRange[0] - 1].name + ", "
      } else {
        result +=
          months[currentRange[0] - 1].name +
          "-" +
          months[currentRange[currentRange.length - 1] - 1].name +
          ", "
      }
      currentRange = [sortedNumbers[i]]
    } else {
      currentRange.push(sortedNumbers[i])
    }
  }

  if (currentRange.length === 1) {
    result += months[currentRange[0] - 1].name
  } else {
    result +=
      months[currentRange[0] - 1].name +
      "-" +
      months[currentRange[currentRange.length - 1] - 1].name
  }

  return result
}
